import ads from '../../images/icons/ads.svg';
import arrowDownSmall from '../../images/icons/arrow-down-small.svg';
import arrowRight from '../../images/icons/arrow-right.svg';
import arrowUpSmall from '../../images/icons/arrow-up-small.svg';
import assets from '../../images/icons/assets.svg';
import back from '../../images/icons/back.svg';
import calendar from '../../images/icons/calendar.svg';
import captain from '../../images/icons/captain.svg';
import change from '../../images/icons/change.svg';
import check from '../../images/icons/check.svg';
import clock from '../../images/icons/clock.svg';
import close from '../../images/icons/close.svg';
import controlCenter from '../../images/icons/control-center.svg';
import dashboard from '../../images/icons/dashboard.svg';
import download from '../../images/icons/download.svg';
import dropdown from '../../images/icons/dropdown.svg';
import ellipsis from '../../images/icons/ellipsis.svg';
import error from '../../images/icons/error.svg';
import filter from '../../images/icons/filter.svg';
import link from '../../images/icons/link.svg';
import linkedAbove from '../../images/icons/linked-above.svg';
import list from '../../images/icons/list.svg';
import liveScore from '../../images/icons/live-score.svg';
import loader from '../../images/icons/loader.svg';
import lock from '../../images/icons/lock.svg';
import logout from '../../images/icons/logout.svg';
import match from '../../images/icons/match.svg';
import menu from '../../images/icons/menu.svg';
import minus from '../../images/icons/minus.svg';
import panels from '../../images/icons/panels.svg';
import pause from '../../images/icons/pause.svg';
import pencil from '../../images/icons/pencil.svg';
import play from '../../images/icons/play.svg';
import plus from '../../images/icons/plus.svg';
import preview from '../../images/icons/preview.svg';
import profile from '../../images/icons/profile.svg';
import question from '../../images/icons/question.svg';
import refresh from '../../images/icons/refresh.svg';
import remove from '../../images/icons/remove.svg';
import search from '../../images/icons/search.svg';
import settings from '../../images/icons/settings.svg';
import rugbyLeague from '../../images/icons/sports/rugby-league.svg';
import rugbyUnion from '../../images/icons/sports/rugby-union.svg';
import soccer from '../../images/icons/sports/soccer.svg';
import { default as footballRedCard, default as footballYellowCard } from '../../images/icons/sports/soccer/card.svg';
import footballCorner from '../../images/icons/sports/soccer/corner.svg';
import footballFoul from '../../images/icons/sports/soccer/foul.svg';
import footballFreeKick from '../../images/icons/sports/soccer/free-kick.svg';
import footballGoal from '../../images/icons/sports/soccer/goal.svg';
import footballPenaltyAwarded from '../../images/icons/sports/soccer/penalty-awarded.svg';
import footballShotTarget from '../../images/icons/sports/soccer/shot-target.svg';
import footballSubs from '../../images/icons/sports/soccer/subs.svg';
import themes from '../../images/icons/themes.svg';
import upload from '../../images/icons/upload.svg';
import warning from '../../images/icons/warning.svg';
export const icons = {
    ads,
    back,
    clock,
    dropdown,
    link,
    loader,
    menu,
    pencil,
    profile,
    search,
    themes,
    arrowDownSmall,
    arrowUpSmall,
    calendar,
    close,
    ellipsis,
    linkedAbove,
    dashboard,
    lock,
    minus,
    play,
    question,
    settings,
    warning,
    arrowRight,
    captain,
    controlCenter,
    error,
    list,
    logout,
    panels,
    plus,
    refresh,
    assets,
    check,
    download,
    filter,
    liveScore,
    match,
    pause,
    preview,
    remove,
    change,
    upload,
    rugbyLeague,
    rugbyUnion,
    soccer,
    footballRedCard,
    footballYellowCard,
    footballCorner,
    footballFoul,
    footballFreeKick,
    footballGoal,
    footballPenaltyAwarded,
    footballShotTarget,
    footballSubs
};
//# sourceMappingURL=icons.js.map